// https://github.com/johnantoni/jquery.alphanumeric
(function ($) {
    $.fn.alphanumeric = function (p) {
        var input = $(this),
            az = "abcdefghijklmnopqrstuvwxyz",
            options = $.extend({
                ichars: '!@#$%^&*()+=[]\\\';,/{}|":<>?~`.- _',
                nchars: '',
                allow: '',
                validationType:'',
                regexpression:''                
            }, p),
            s = options.allow.split(''),
            i = 0,
            ch,
            regex;
        
        for (i; i < s.length; i++) {
            if (options.ichars.indexOf(s[i]) != -1) {
                s[i] = '\\' + s[i];
            }
        }

        if (options.nocaps) {
            options.nchars += az.toUpperCase();
        }
        if (options.allcaps) {
            options.nchars += az;
        }
		if($(this).hasClass('allowNegative'))
		{
			s.push('-');
		}
        options.allow = s.join('|');

        regex = new RegExp(options.allow, 'gi');
        ch = (options.ichars + options.nchars).replace(regex, '');

        input.keypress(function (e) {
            var key = String.fromCharCode(!e.charCode ? e.which : e.charCode);

            if (ch.indexOf(key) != -1 && !e.ctrlKey) {
                e.preventDefault();
            }
            
            if(options.validationType=='float')
            {
                var precision = p.precision;
                if(precision>0)
                {
                    var value = input.val();
                    var dotParts = value.split('.');
                    if(dotParts.length>1 && key=='.')
                    {
                        e.preventDefault();
                    }                    
                }
                
                
            }
        });
        
        input.keyup(function (e) {
            var key          = String.fromCharCode(!e.charCode ? e.which : e.charCode);
            var currentValue = input.val();
            if(options.validationType=='float')
            {
                var precision = p.precision;
                var newValue  = $(this).getFloatNumber(input,currentValue,p,e);
                input.val(newValue);
            }           
        });

        input.blur(function (e) {
            var checkFlag = true;
            var value = input.val(),
                j = 0;
            for (j; j < value.length; j++) {
                if (ch.indexOf(value[j]) != -1 && checkFlag==true) {
                    input.val('');
                    var checkFlag = false;
                    //return false;
                }
            }
            
            if(checkFlag==false)
            {
                var showWarning = input.data('shownonnumericwarning');
                if(showWarning==true)
                {
                    var warningMsg = input.data('nonnumericwarningmsg');
                    alert(warningMsg);
                    input.focus(); 
                    window.getSelection().removeAllRanges(); // http://stackoverflow.com/questions/23432592/javascript-firefox-behavior-blur-by-mouse-click-bug
                   
                }
            }
            
            if(options.validationType=='float')
            {
                var precision = p.precision;
                var newValue  = $(this).getFloatNumber(input,value,p,e);
                input.val(newValue);
            }
            
                       
            
            return checkFlag;
        });

        return input;
    };

    $.fn.numeric = function (p) {
        var az = 'abcdefghijklmnopqrstuvwxyz',
            aZ = az.toUpperCase();

        return this.each(function () {
            $(this).alphanumeric($.extend({ nchars: az + aZ }, p));
        });
    };
    
    $.fn.floatNumbers = function (p) {
        var az = 'abcdefghijklmnopqrstuvwxyz',
        aZ = az.toUpperCase();
        var validationResult = true;
        
        var precision = 2;
        var intLength = 6;
        var rangeStart= '';
        var rangeEnd  = '';
        
        
        if(typeof p != 'undefined')
        {            
            if(typeof p.precision != 'undefined' && p.precision!=="")
            {
                 var precision = p.precision;
            }
            if(typeof p.intLength != 'undefined' && p.intLength!=="")
            {
                var intLength = p.intLength;
            }
            if(typeof p.rangeStart != 'undefined' && p.rangeStart!=="")
            {
                var rangeStart = p.rangeStart;
            }
            if(typeof p.rangeEnd != 'undefined' && p.rangeEnd!=="")
            {
                var rangeEnd = p.rangeEnd;
            }
        }else
        {
            var p = {};
        }
        if(precision>0)
        {
            p.allow = '.';
        }
         
        
        var result =  this.each(function () {
            if(validationResult==false)
            {
                return false;
            }
            p.validationType = 'float';
            p.regexpression  = '';
            p.precision      = precision;
            p.intLength      = intLength;
            p.rangeStart     = rangeStart;
            p.rangeEnd       = rangeEnd;
            $(this).alphanumeric($.extend({ nchars: az + aZ }, p));            
        });
    };
    
    

    $.fn.alpha = function (p) {
        var nm = '1234567890';
        return this.each(function () {
            $(this).alphanumeric($.extend({ nchars: nm }, p));
        });
    };
    
    $.fn.getFloatNumber = function (input,currentValue,p,e){
        var intPart     = '';
        var decimalPart = '';
        var newValue    = '';
        var precision   = p.precision;
        var intLength   = p.intLength;
        if(precision>0)
        {
            var dotParts = currentValue.split('.');
            if(dotParts[0].length>intLength)
            {
                intPart = dotParts[0].substring(0, intLength);
            }else
            {
                intPart = dotParts[0];
            }
            
            
            if(dotParts.length>1 && dotParts[1].length>precision)
            {
                decimalPart = dotParts[1].substring(0, precision);
                decimalPart = '.'+decimalPart
            }else if(dotParts.length>1)
            {
                decimalPart = '.'+dotParts[1];
            }  
            if(intPart=='' && dotParts.length>1){ intPart = 0; }
            if(intPart!==""){ intPart = parseInt(intPart); }
            var newValue = intPart+decimalPart;
        }else
        {  
            if(currentValue.length > intLength)
            {
                intPart = currentValue.substring(0,intLength);
            }else
            {
               intPart =  currentValue;
            }
            var newValue = intPart;
            if(newValue!==""){ newValue = parseInt(newValue); }
        }


        var error = false;
        if(newValue!="")
        {
            if(error== false && e.type == 'blur' && p.rangeStart!='')
            {
                if(parseFloat(newValue) < p.rangeStart)
                {
                    newValue = '';
                    error    = true;
                    alert('Only values greater than or equal to '+p.rangeStart+' is allowed.');
                    $(input).focus();
                    
                }
            }
            if(error == false && e.type == 'blur' && p.rangeEnd!='')
            {
                if(parseFloat(newValue) > p.rangeEnd)
                {
                    newValue = '';
                    error    = true;
                    alert('Only values lesser than or equal to '+p.rangeEnd+' is allowed.');
                    $(input).focus();
                }
            }
            
            
        }
        
        return newValue;
        
        
    };
})(jQuery);